// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabbar-area {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabbar {
  position: relative;
  display: flex;
  height: 70px;
  padding: 4px 16px 8px;
  border-radius: 9999px;
  background-color: #FFFFFF;
  justify-content: space-between;
  margin: 0 16px 16px;
  max-width: 384px;
  width: 100%;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.4196078431);
}

.tabbar-item {
  display: flex;
  justify-content: center;
  color: black;
  align-items: center;
  font-size: 24px;
  flex: 2;
}
.tabbar-item.active {
  color: #FFC61D;
}

.qr-area {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 3;
}
.qr-area > div {
  width: 60px;
  height: 60px;
  border-radius: 9999px;
  background-color: #FFC61D;
}
.qr-area > div > div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.qr-area > div > div > ion-icon {
  font-size: 24px;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tabbar/tabbar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,oDAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;AACF;AAAE;EACE,cAAA;AAEJ;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;AACF;AAAE;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;AAEJ;AADI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAGN;AAFM;EACE,eAAA;EACA,YAAA;AAIR","sourcesContent":[".tabbar-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tabbar {\n  position: relative;\n  display: flex;\n  height: 70px;\n  padding: 4px 16px 8px;\n  border-radius: 9999px;\n  background-color: #FFFFFF;\n  justify-content: space-between;\n  margin: 0 16px 16px;\n  max-width: 384px;\n  width: 100%;\n  box-shadow: 0px 4px 16px #0000006b;\n}\n\n.tabbar-item {\n  display: flex;\n  justify-content: center;\n  color: black;\n  align-items: center;\n  font-size: 24px;\n  flex: 2;\n  &.active {\n    color: #FFC61D;\n  }\n}\n\n.qr-area {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 3;\n  & > div {\n    width: 60px;\n    height: 60px;\n    border-radius: 9999px;\n    background-color: #FFC61D;\n    & > div {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 100%;\n      & > ion-icon {\n        font-size: 24px;\n        color: black;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
